import { PostStore, PostStoreInterface } from '@/blog/infrastructure/store/PostStore';
import { getStore, usePlocState } from '@hfc/ui-core';

interface UsePostStoreInterface {
  postStore: PostStore;
  postState: ReturnType<typeof usePlocState<PostStoreInterface>>
}

export function usePostStore (): UsePostStoreInterface {
  const postStore = getStore<PostStore>('PostStore', PostStore);
  const postState = usePlocState(postStore);

  return {
    postStore,
    postState
  };
}
